import React    from 'react';
import cx       from 'classnames';

export default class Slider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeID: 0,
        };

        this.timer = null;
        this.handleScroll = this.handleScroll.bind(this);
    }
    changeActive = (id) => {
        this.setState({
            activeID: id,
        });
    };

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount(){
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll (event) {
        event.preventDefault();
        event.stopPropagation();

        // решить с прокруткой

        // if(window.pageYOffset > 1450) window.scrollTo(0, 1450);

        if(this.timer) clearTimeout(this.timer);

        if(window.pageYOffset >= 1450 && false) {
            this.timer = setTimeout(() => {
                let newID = this.state.activeID < (this.props.data.length - 1) ? this.state.activeID + 1 : this.state.activeID;
                if(newID !== this.state.activeID) this.setState({activeID: newID,});
            }, 500);
        }
    };

    render() {
        const { id } = this.props;
        return (
            <div id={'slider-' + id } className="slider">
                <div className="container">
                    <Selectors
                        data={this.props.data}
                        activeID={this.state.activeID}
                        changeActive={this.changeActive}
                    />
                    <Panel child={this.props.data[this.state.activeID].elem} />
                </div>
            </div>
        );
    }
}
class Panel extends React.Component {
    render() {
        const { child } = this.props;

        return (
            <aside className="panel">
                {child}
            </aside>
        );
    }
}
class Selectors extends React.Component {
    handleClick(e) {
        if (this.props.id !== this.props.activeID) {
            this.props.changeActive(this.props.id);
        } else {
            return;
        }
    }
    render() {
        return (
            <div className="selectors">
                {this.props.data.map((item) =>
                    <Selector
                        key={item.id}
                        id={item.id}
                        handleClick={this.handleClick}
                        changeActive={this.props.changeActive}
                        activeID={this.props.activeID}
                    />
                )}
            </div>
        );
    }
}
class Selector extends React.Component {
    render() {
        let componentClass = cx({
            selector: true,
            active: this.props.activeID === this.props.id
        });

        return (
            <div className={componentClass} onClick={this.props.handleClick.bind(this)}></div>
        );
    }
}



